/**
 * カスタムJavaScript - pt-morooka
 * Shopify Dawnテーマ用カスタムスクリプト
 */

// ページ読み込み完了時の処理
document.addEventListener('DOMContentLoaded', function() {
  console.log('pt-morooka custom scripts loaded');
  
  // ヒーローセクションのアニメーション
  initHeroAnimations();
  
  // カスタムバナーの処理
  initCustomBanners();
});

/**
 * ヒーローセクションのアニメーション初期化
 */
function initHeroAnimations() {
  const heroSections = document.querySelectorAll('.morooka-hero-nature');
  
  heroSections.forEach(section => {
    // パララックス効果は削除（transform: translateYが不要のため）
    
    // ボタンのホバーエフェクトは削除（CSSで管理）
  });
}

/**
 * カスタムバナーの処理
 */
function initCustomBanners() {
  const customBanners = document.querySelectorAll('.morooka-style-banner');
  
  customBanners.forEach(banner => {
    // フェードインアニメーション
    if (isInViewport(banner)) {
      banner.classList.add('morooka-fade-in');
    }
    
    // スクロール監視
    window.addEventListener('scroll', () => {
      if (isInViewport(banner) && !banner.classList.contains('morooka-fade-in')) {
        banner.classList.add('morooka-fade-in');
      }
    });
  });
}

/**
 * 要素がビューポート内にあるかチェック
 */
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * モバイルメニューのカスタマイズ（必要に応じて）
 */
function initMobileMenu() {
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function() {
      document.body.classList.toggle('morooka-mobile-menu-open');
    });
  }
}

// カスタムアニメーションクラス
const style = document.createElement('style');
style.textContent = `
  .morooka-fade-in {
    animation: morookaFadeIn 0.8s ease-in-out;
  }
  
  @keyframes morookaFadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
document.head.appendChild(style);